<!-- 支付宝 -->
<template>
    <div  class="business-content-main" v-cloak>
        <div class="pay-state-ctn" >
            <div class="pay-state" v-if="state == 0">
                <img src="../../../assets/images/success.png" alt="">
                <span>恭喜您，支付成功！</span>
            </div>
            <div class="pay-state" v-else-if="state == 1">
                <img src="../../../assets/images/fail.png" alt="">
                <span>交易正在支付中...</span>
            </div>
            <div class="order-msg">
                <p><span>订单号：</span> <span>{{osn}}</span> </p>
                <p><span>订单金额：</span> <span>￥{{surplusMoney}}</span> </p>
            </div>
<!--            <div class="gotoOrderDetails">-->
<!--                <span @click="gotoOrderDetails" v-if="state == 0">订单详情</span>-->
<!--                <span @click="gotoPay" v-else>重新支付</span>-->
<!--            </div>-->
        </div>
    </div>
</template>
<script>
    import mixin from  '@/mixins/mixin'
    export default {
        mixins: [mixin],
        name: '',
        components: {

        },
        data(){
            return {
                state:-1,
                osn:'',
                surplusMoney:'',
                subData:{},
            }
        },
        mounted(){
            this.subData = this.$route.query
            this.osn = this.subData.out_trade_no
            this.surplusMoney = this.subData.total_amount
            this.getResult()
        },
        methods:{
            gotoOrderDetails(){

            },
            gotoPay(){

            },
            getResult(){
                this.$util.axiosGet({
                    url:'/api/PaymentNotify/Callback',
                    data:this.subData,
                }).then((res)=>{
                    this.state = res.data
                    if (this.state == 1){
                        this.$util.warningMsg(res.errmsg)
                    }
                })
            },
        }
    }
</script>
<style lang="less" scoped>
    .gotoOrderDetails {
        font-size: 18px;
        text-align: center;
        color: @theme;
        cursor: pointer;margin-top: 30px;
    }
    .pay-state-ctn {
        width: 1000px;
        margin: 0 auto;
    }
    .pay-state{
        margin-top: 80px;
        width: 1000px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        font-weight: 200;
        img {
            margin-right: 20px;
            width: 80px;
            height: 80px;
        }
    }
    .order-msg {
        width: 1000px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 50px;
        p {
            line-height: 1.5em;
            width: 386px;
            font-size: 18px;
            font-weight: 200;
            display: flex;
            justify-content: space-between;
        }
    }
</style>
